import { asInstant, mapObjectList, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.comment.Comment
 *
 * @typedef {object} CommentData
 * @property {string|null} commentId
 * @property {string|null} comment
 * @property {number|string|null} timestamp
 * @property {string|null} userId
 * @property {string|null} name
 */

/**
 * @param {object} raw
 * @returns {CommentData}
 */
export function fromCommentData(raw) {
  const source = requireObject(raw, 'Comment');
  return {
    commentId: optionalString(source.commentId),
    comment: optionalString(source.comment),
    timestamp: asInstant(source.timestamp),
    userId: optionalString(source.userId),
    name: optionalString(source.name),
  };
}

/**
 * @param {unknown} raw
 * @returns {CommentData[]}
 */
export function fromCommentDataList(raw) {
  return mapObjectList(raw, fromCommentData);
}
